import AssistantCreateExam from "../../components/courses/assistantCreateExam"

const CreateAssistantExam = () => {
    return <AssistantCreateExam/>
}
export default CreateAssistantExam